import React from 'react';
import axios from 'axios';
import { createRoot } from 'react-dom/client';
import WebFont from 'webfontloader';

import config from './constants/config';
import './index.css';
import './assets/polyfills';
import App from './App';
import 'semantic-ui-less/semantic.less';

axios.defaults.baseURL = config.BASE_URL;

WebFont.load({
    google: {
        families: ['Open Sans:300,400,600,700,800', 'sans-serif'],
    },
    custom: {
        families: ['icomoon', 'Open Sans'],
        urls: ['/icon-fonts.css', '/open-sans.css'],
    },
});

const root = createRoot(document.getElementById('root'));

root.render(<App />);
